import * as moment from 'moment';
import { Component, FormEvent } from 'react';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, FollowUpActionCreators, IApplicationState, IFollowUpSurveyResponse } from '@nkr/store/index';
import { IBaseResponse, IFollowUpSurvey, IListItem } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Label } from 'react-bootstrap';
import { toast } from 'react-toastify';

interface IProps {
    surveyId: number,
    isAdmin: boolean
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getFollowUpSurvey: (id: number) => Promise<IFollowUpSurveyResponse>,
    markComplete: (id: number, completedDateTime: string, areLabResultsGood: boolean, isNotifiedOfLabResults: boolean, labResultsReviewedByContactId: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IValidation {
    completedDateTime: boolean,
    areLabResultsGood: boolean,
    isNotifiedOfLabResults: boolean,
    labResultsReviewedByContactId: boolean
}

interface IState {
    data: IFollowUpSurvey,
    completedDateTime: string,
    areLabResultsGood: number,
    isNotifiedOfLabResults: number,
    labResultsReviewedByContactId: number,
    validation: IValidation,
    dirty: boolean,
    error: string,
    reviewers: IListItem[]
}

class MarkComplete extends Component<TProps, IState> {
    readonly state: IState = {
        data: null,
        completedDateTime: moment().format('YYYY-MM-DD'),
        areLabResultsGood: -1,
        isNotifiedOfLabResults: -1,
        labResultsReviewedByContactId: 0,
        validation: {
            completedDateTime: true,
            areLabResultsGood: true,
            isNotifiedOfLabResults: true,
            labResultsReviewedByContactId: true
        },
        dirty: false,
        error: '',
        reviewers: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting survey details, one moment please...').then(() => {
            this.props.getFollowUpSurvey(this.props.surveyId).then(response => {
                this.setState({
                    data: response.data.results.current,
                    reviewers: response.data.results.reviewers
                });

                this.props.hideLoading();
            });
        });
    }

    validate = (): IValidation => {
        let { completedDateTime, areLabResultsGood, isNotifiedOfLabResults, labResultsReviewedByContactId } = this.state;

        return {
            completedDateTime: moment(completedDateTime, 'YYYY-MM-DD', true).isValid(),
            areLabResultsGood: areLabResultsGood != -1,
            isNotifiedOfLabResults: areLabResultsGood == 0 ? isNotifiedOfLabResults != -1 : true,
            labResultsReviewedByContactId: labResultsReviewedByContactId > 0
        };
    }

    isValid = () => {
        let { completedDateTime, areLabResultsGood, isNotifiedOfLabResults, labResultsReviewedByContactId } = this.state.validation;

        return completedDateTime && areLabResultsGood && isNotifiedOfLabResults && labResultsReviewedByContactId;
    }

    handleCompletedDateTimeChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            completedDateTime: e.currentTarget.value
        });
    }

    handleAreLabResultsGoodChange = (areLabResultsGood: number) => {
        this.setState({
            areLabResultsGood
        });
    };

    handleIsNotifiedOfLabResultsChange = (isNotifiedOfLabResults: number) => {
        this.setState({
            isNotifiedOfLabResults
        });
    };

    handleReviewerChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            labResultsReviewedByContactId: parseInt(e.currentTarget.value)
        });
    }

    handleSubmit = () => {
        let validation = this.validate();

        this.setState({
            validation,
            dirty: true
        }, () => {
            if (this.isValid()) {
                let { completedDateTime, areLabResultsGood, isNotifiedOfLabResults, labResultsReviewedByContactId } = this.state;

                this.props.showLoading('Updating survey, one moment please...').then(() => {
                    this.props.markComplete(this.props.surveyId, completedDateTime, areLabResultsGood == 1, isNotifiedOfLabResults == 1, labResultsReviewedByContactId)
                        .then(response => {
                            if (response.data.success) {
                                toast.success('Successful, going back to the list', {
                                    onClose: () => {
                                        window.location.href = `/center/${this.state.data.centerId}/follow-up/surveys`;
                                    }
                                });
                            }

                            this.props.hideLoading();
                        })
                        .catch(error => {
                            this.setState({
                                error: error.message
                            });

                            console.log(error);

                            this.props.hideLoading();
                        });
                });
            }
        });
    }

    handleCancel = () => {
        if (this.props.isAdmin) {
            window.location.href = '/admin/follow-up/surveys';
        } else {
            window.location.href = '/center/' + this.state.data.centerId + '/follow-up/surveys';
        }
    }

    render = () => {
        const fullName = this.state.data != null ? this.state.data.fullName : '';
        const status = this.state.data != null ? this.state.data.status : '';
        const isValid = this.isValid();

        return (
            <div className='container' style={{ paddingTop: 20, minHeight: '75vh' }}>
                {isValid == false && (
                    <Alert bsStyle='danger'>
                        Items in red must be completed...
                    </Alert>
                )}

                {this.state.error != '' && (
                    <Alert bsStyle='danger'>
                        <div style={{ marginBottom: 5 }}>We were unable to update the survey due to the following error:</div>
                        <blockquote>{this.state.error}</blockquote>
                    </Alert>
                )}

                {/* <div style={{ marginBottom: 30 }}>
                    <h3 className='text-left' style={{ margin: 0 }}>Mark Follow-Up Survey Complete</h3>
                </div> */}

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
                    <h1 className='text-left' style={{ margin: 0 }}>Mark Follow-Up Survey Complete</h1>
                    <div className="dropdown pull-right">
                        <Button bsStyle='link' onClick={this.handleCancel}>Return to List</Button>
                    </div>
                </div>

                <br />

                <div style={{ padding: 20, border: '1px solid #ccc', borderRadius: 4 }}>
                    <Form horizontal>
                        <FormGroup>
                            <Col xs={12} sm={4} componentClass={ControlLabel}>
                                Name:
                            </Col>
                            <Col xs={12} sm={4}>
                                <FormControl.Static style={{ backgroundColor: '#eee', borderRadius: 4, paddingLeft: 5 }}>{fullName}</FormControl.Static>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} sm={4} componentClass={ControlLabel}>
                                Status:
                            </Col>
                            <Col xs={12} sm={4}>
                                <FormControl.Static style={{ backgroundColor: '#eee', borderRadius: 4, paddingLeft: 5 }}>{status}</FormControl.Static>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={this.state.dirty && this.state.validation.completedDateTime == false ? 'error' : null}>
                            <Col xs={12} sm={4} componentClass={ControlLabel}>
                                Completed:
                            </Col>
                            <Col xs={12} sm={4}>
                                <FormControl
                                    type='date'
                                    value={this.state.completedDateTime}
                                    onChange={this.handleCompletedDateTimeChange}
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={this.state.dirty && this.state.validation.areLabResultsGood == false ? 'error' : null}>
                            <Col xs={12} sm={4} componentClass={ControlLabel}>
                                What is the status of the results?<br />
                            </Col>
                            <Col xs={12} sm={4}>
                                <label className='radio-inline'>
                                    <input name='AreLabResultsGood' type='radio' value='0' checked={this.state.areLabResultsGood === 0} onClick={() => this.handleAreLabResultsGoodChange(0)} /> Abnormal
                                </label>
                                <label className='radio-inline'>
                                    <input name='AreLabResultsGood' type='radio' value='1' checked={this.state.areLabResultsGood === 1} onClick={() => this.handleAreLabResultsGoodChange(1)} /> Normal
                                </label>
                            </Col>
                        </FormGroup>

                        {!this.state.areLabResultsGood && (
                            <FormGroup validationState={this.state.dirty && this.state.validation.isNotifiedOfLabResults == false ? 'error' : null}>
                                <Col xs={12} sm={4} componentClass={ControlLabel}>
                                    Has the donor been notified of the lab results?<br />
                                </Col>
                                <Col xs={12} sm={8}>
                                    <label className='radio-inline'>
                                        <input name='IsNotifiedOfLabResults' type='radio' value='1' checked={this.state.isNotifiedOfLabResults === 1} onClick={() => this.handleIsNotifiedOfLabResultsChange(1)} />  Yes
                                    </label>
                                    <label className='radio-inline'>
                                        <input name='IsNotifiedOfLabResults' type='radio' value='0' checked={this.state.isNotifiedOfLabResults === 0} onClick={() => this.handleIsNotifiedOfLabResultsChange(0)} /> No
                                        {this.state.isNotifiedOfLabResults === 0 && (
                                            <Label bsStyle='warning' style={{ marginLeft: 10 }}>This will stay in Pend Notify Donor tab until this is marked Yes</Label>
                                        )}
                                    </label>
                                </Col>
                            </FormGroup>
                        )}

                        <FormGroup validationState={this.state.dirty && this.state.validation.labResultsReviewedByContactId == false ? 'error' : null}>
                            <Col xs={12} sm={4} componentClass={ControlLabel}>
                                Who reviewed the results?<br />
                            </Col>
                            <Col xs={12} sm={4}>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.labResultsReviewedByContactId}
                                    onChange={this.handleReviewerChange}
                                >
                                    <option value={0}>- Select -</option>
                                    {this.state.reviewers.map(item =>
                                        <option key={'rev-' + item.id} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        <FormGroup style={{ marginBottom: 0 }}>
                            <Col xs={12} sm={2} smOffset={4}>
                                <Button bsStyle='primary' block style={{ marginRight: 5 }} onClick={this.handleSubmit}>Mark Complete</Button>
                            </Col>
                            <Col xs={12} sm={2}>
                                <Button block onClick={this.handleCancel}>Cancel</Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        // app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getFollowUpSurvey: (id) => {
            return dispatch(FollowUpActionCreators.getSurvey(id));
        },
        markComplete: (id, completedDateTime, areLabResultsGood, isNotifiedOfLabResults, labResultsReviewedByContactId) => {
            return dispatch(FollowUpActionCreators.markCompleted(id, completedDateTime, areLabResultsGood, isNotifiedOfLabResults, labResultsReviewedByContactId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(MarkComplete);